/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ContactDetailsViewModel } from './ContactDetailsViewModel';
import {
    ContactDetailsViewModelFromJSON,
    ContactDetailsViewModelFromJSONTyped,
    ContactDetailsViewModelToJSON,
} from './ContactDetailsViewModel';
import type { ContactPersonViewModel } from './ContactPersonViewModel';
import {
    ContactPersonViewModelFromJSON,
    ContactPersonViewModelFromJSONTyped,
    ContactPersonViewModelToJSON,
} from './ContactPersonViewModel';
import type { NonTaxableInstitutionPartyDetailsViewModel } from './NonTaxableInstitutionPartyDetailsViewModel';
import {
    NonTaxableInstitutionPartyDetailsViewModelFromJSON,
    NonTaxableInstitutionPartyDetailsViewModelFromJSONTyped,
    NonTaxableInstitutionPartyDetailsViewModelToJSON,
} from './NonTaxableInstitutionPartyDetailsViewModel';
import type { OrganisationAddressesViewModel } from './OrganisationAddressesViewModel';
import {
    OrganisationAddressesViewModelFromJSON,
    OrganisationAddressesViewModelFromJSONTyped,
    OrganisationAddressesViewModelToJSON,
} from './OrganisationAddressesViewModel';

/**
 * 
 * @export
 * @interface NonTaxableInstitutionDetailsViewModel
 */
export interface NonTaxableInstitutionDetailsViewModel {
    /**
     * 
     * @type {number}
     * @memberof NonTaxableInstitutionDetailsViewModel
     */
    partyId: number;
    /**
     * 
     * @type {NonTaxableInstitutionPartyDetailsViewModel}
     * @memberof NonTaxableInstitutionDetailsViewModel
     */
    policyHolderDetails?: NonTaxableInstitutionPartyDetailsViewModel;
    /**
     * 
     * @type {ContactPersonViewModel}
     * @memberof NonTaxableInstitutionDetailsViewModel
     */
    contactPerson?: ContactPersonViewModel;
    /**
     * 
     * @type {ContactDetailsViewModel}
     * @memberof NonTaxableInstitutionDetailsViewModel
     */
    contactDetails?: ContactDetailsViewModel;
    /**
     * 
     * @type {OrganisationAddressesViewModel}
     * @memberof NonTaxableInstitutionDetailsViewModel
     */
    addresses?: OrganisationAddressesViewModel;
    /**
     * 
     * @type {boolean}
     * @memberof NonTaxableInstitutionDetailsViewModel
     */
    isComplete: boolean;
}

/**
 * Check if a given object implements the NonTaxableInstitutionDetailsViewModel interface.
 */
export function instanceOfNonTaxableInstitutionDetailsViewModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "partyId" in value;
    isInstance = isInstance && "isComplete" in value;

    return isInstance;
}

export function NonTaxableInstitutionDetailsViewModelFromJSON(json: any): NonTaxableInstitutionDetailsViewModel {
    return NonTaxableInstitutionDetailsViewModelFromJSONTyped(json, false);
}

export function NonTaxableInstitutionDetailsViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): NonTaxableInstitutionDetailsViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'partyId': json['PartyId'],
        'policyHolderDetails': !exists(json, 'PolicyHolderDetails') ? undefined : NonTaxableInstitutionPartyDetailsViewModelFromJSON(json['PolicyHolderDetails']),
        'contactPerson': !exists(json, 'ContactPerson') ? undefined : ContactPersonViewModelFromJSON(json['ContactPerson']),
        'contactDetails': !exists(json, 'ContactDetails') ? undefined : ContactDetailsViewModelFromJSON(json['ContactDetails']),
        'addresses': !exists(json, 'Addresses') ? undefined : OrganisationAddressesViewModelFromJSON(json['Addresses']),
        'isComplete': json['IsComplete'],
    };
}

export function NonTaxableInstitutionDetailsViewModelToJSON(value?: NonTaxableInstitutionDetailsViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'PartyId': value.partyId,
        'PolicyHolderDetails': NonTaxableInstitutionPartyDetailsViewModelToJSON(value.policyHolderDetails),
        'ContactPerson': ContactPersonViewModelToJSON(value.contactPerson),
        'ContactDetails': ContactDetailsViewModelToJSON(value.contactDetails),
        'Addresses': OrganisationAddressesViewModelToJSON(value.addresses),
        'IsComplete': value.isComplete,
    };
}

